// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__344uf","actions":"GroupTable_actions__3m_7S","deleteModalFooter":"GroupTable_deleteModalFooter__2wM5o"};